import { Fragment } from "react"
import { FiltersProvider } from "../../components/providers/FiltersProvider"
import OperationsPendingTasks from "./pendingTask-list/OperationPendingTask"

const PendingTaskListWrapper = () => {

    return (
        <Fragment>
            <FiltersProvider>
                <OperationsPendingTasks />
            </FiltersProvider>
        </Fragment>
    )
}

export default PendingTaskListWrapper